/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Activity_Time_OutInputs */



/**
* | output |
* | --- |
* | "Out" |
*
* @param {Assistant_Activity_Time_OutInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_activity_time_out = /** @type {((inputs?: Assistant_Activity_Time_OutInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Activity_Time_OutInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Dehors")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aus")
	if (locale === "it") return /** @type {LocalizedString} */ ("Fuori")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вне")
	if (locale === "es") return /** @type {LocalizedString} */ ("Afuera")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("出去")
	if (locale === "ja") return /** @type {LocalizedString} */ ("外")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बाहर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Fora")
	return /** @type {LocalizedString} */ ("Out")
});